import Service from "../Service";
const resource = "frzdamagejaba/";

export default {
    save(prd, requestID) {
        return Service.post(resource + "save", prd, {
            params: { requestID: requestID },
        });
    },

    list(obj, requestID) {
        return Service.post(resource + "list", obj, {
            params: { requestID: requestID },
        });
    },

    listreceptionfrozen(obj, requestID) {
        return Service.post(resource + "listreceptionfrozen", obj, {
            params: { requestID: requestID },
        });
    },

};